import { render } from "./ReopenTicketModal.vue?vue&type=template&id=6b9c5c56"
import script from "./ReopenTicketModal.vue?vue&type=script&lang=js"
export * from "./ReopenTicketModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/modals/ReopenTicketModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b9c5c56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b9c5c56', __exports__)) {
    api.reload('6b9c5c56', __exports__)
  }
  
  module.hot.accept("./ReopenTicketModal.vue?vue&type=template&id=6b9c5c56", () => {
    api.rerender('6b9c5c56', render)
  })

}


export default __exports__